import {
  GET_CHECKOUT_PREVIEW_REQUEST,
  GET_CHECKOUT_PREVIEW_SUCCESS,
  GET_CHECKOUT_PREVIEW_FAIL,
  SAVE_TOKEN_REQUEST,
  SAVE_TOKEN_FAIL,
  SAVE_TOKEN_SUCCESS
} from "../constants/checkout";

const initialState = {
  loading: false,
  preview: null,
  startTime: null,
  error: null
};

export default function checkoutReducer(state = initialState, action) {
  switch (action.type) {
    case GET_CHECKOUT_PREVIEW_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case GET_CHECKOUT_PREVIEW_SUCCESS:
      return {
        ...state,
        preview: action.payload,
        startTime: action.payload.startTime,
        loading: false
      };
    case GET_CHECKOUT_PREVIEW_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    case SAVE_TOKEN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case SAVE_TOKEN_SUCCESS:
      return {
        ...state,
        loading: true,
        checkout: action.payload
      };
    case SAVE_TOKEN_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    default:
      return state;
  }
}
